import { Box, InputAdornment, Link } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import TextField from '@mui/material/TextField';
import CopyToClipboardButton from '@shared/components/others/CopyToClipboardButton/CopyToClipboardButton';
import PasswordTextField from '@shared/components/others/PasswordTextField/PasswordTextField';
import { useTranslation } from 'react-i18next';
import { DeviceForCredentials, TrafficGeneratorBookingCredentials } from '../types';
import { FC } from 'react';
import { toTitleCase } from '@shared/utils/utilsOld';

interface BookingDeviceTrafficGeneratorCredentialsProps {
    credentials: TrafficGeneratorBookingCredentials;
    selectedDevice: DeviceForCredentials;
}

const BookingDeviceTrafficGeneratorCredentials: FC<BookingDeviceTrafficGeneratorCredentialsProps> = ({
    credentials,
    selectedDevice,
}) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ maxWidth: '217px', mb: 1 }}>
            <Link
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    width: 'min-content',
                    fontSize: '1rem',
                }}
                component="a"
                href={credentials.link}
                target="_blank"
            >
                {credentials.link}
                <OpenInNewIcon fontSize="small" />
            </Link>
            <TextField
                sx={{ mt: 2 }}
                margin="dense"
                size="small"
                disabled
                label={`${toTitleCase(selectedDevice.type)} ${t('login').toLowerCase()}`}
                value={credentials.login}
                slotProps={{
                    input: {
                        endAdornment: (
                            <InputAdornment position="end">
                                <CopyToClipboardButton textToCopy={credentials.login} />
                            </InputAdornment>
                        ),
                    },
                }}
            />
            <PasswordTextField
                showCopyButton
                margin="dense"
                size="small"
                disabled
                type="password"
                label={t('password')}
                value={credentials.password}
            />
        </Box>
    );
};

export default BookingDeviceTrafficGeneratorCredentials;
